import React from 'react';
import Strips from 'styles/staticAssets/images/Strips.svg';
import { ButtonComp as Button } from 'atoms/Buttons';
import Image from 'atoms/Image';
import { getValueOrEmptyString } from 'common/utilities/utils';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';

const ContactUsHeader = ({ headerData, history, isMobile, userParams }) => {
  const { headline, subHeadline, faqButtonData, callUsButtonData, cautionData } = headerData;
  const CustomStyledDiv = useStyleScripts(STYLE_SCRIPT_CONST?.CONTACT_US_CONTAINER_STYLES);
  const phoneNum = 'tel:' + getValueOrEmptyString(callUsButtonData?.phoneNumber);

  return (
    CustomStyledDiv && (
      <CustomStyledDiv className={`contactUs-header-container${userParams?.localized ? ' localized' : ''}`}>
        <img src={Strips} alt='' className='contactUs-icon' />
        <h1 className='contactUs-header'>{headline}</h1>
        <div className='contactUs-subheader'>{subHeadline}</div>
        <div className='button-container'>
          <a tabIndex='-1' href={phoneNum} className='anchorTags'>
            <Button className='button whiteButton blackBorder contactus-button' ariaLable='Call Us 080-4275-4444'>
              <div>
                <Image className='icon' srcFile={callUsButtonData.icon} />
                {callUsButtonData.buttonText} {!isMobile && callUsButtonData.phoneNumber}
              </div>
            </Button>
          </a>
          {isMobile && <span className='space' />}
          {faqButtonData && (
            <Button
              className='button whiteButton blackBorder contactus-button'
              ariaLable='FAQ'
              onClickHandler={e => {
                e.preventDefault();
                history.push({
                  pathname: faqButtonData?.internalurl,
                });
              }}
            >
              {faqButtonData.linkText}
            </Button>
          )}
          {cautionData && (
            <Button
              className='button whiteButton blackBorder contactus-button'
              ariaLable='caution-notice'
              onClickHandler={e => {
                e.preventDefault();
                history.push({
                  pathname: cautionData?.internalurl,
                });
              }}
            >
              {cautionData.linkText}
            </Button>
          )}
        </div>
      </CustomStyledDiv>
    )
  );
};
export default ContactUsHeader;
